import { render, staticRenderFns } from "./extra-fodyn-page.vue?vue&type=template&id=2711bf9d&lang=pug&"
import script from "./extra-fodyn-page.vue?vue&type=script&lang=js&"
export * from "./extra-fodyn-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports